<div class="auditItem Created-Category">

  <div class="auditIconWrap">
    <div class="auditBadgeIcon" *ngIf="false"></div>
    <div class="auditIcon" title="Creation"></div>
  </div>
  <div class="auditInfo">
    <div class="auditHeader"><span class="auditTimestamp">{{created?.updated |  formatDateWithTimezone | async}}</span> <span
        (click)="isSelected ? unselected.emit() : selected.emit()" class="showAuditDetails">
        <mat-icon>info</mat-icon>
      </span></div>
    <div class="auditDescription">
      <p>
        Creato.
      </p>
    </div>
    <div class="auditCommentWrap">

      <div class="auditCommentText">
        <p>
          da {{created?.operator?.displayName}}
        </p>
      </div>
    </div>
  </div>
</div>
